import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the minimal service worker in production only.
// We do NOT use CRA's built-in serviceWorkerRegistration because its
// default Workbox configuration does not enforce the /api/ network-only
// passthrough required by this app (authenticated data must never be cached).
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  try {
    navigator.serviceWorker.register("/sw.js");
  } catch {
    // Progressive enhancement: offline shell failure is non-fatal.
  }
}
